export default "__VITE_ASSET__CdVFd4Dn__"